module.exports = __webpack_public_path__ + "img/prompt-1.a6e09b0b.svg";